export default function getMagicLinkValues() {
    const urlParams = new URLSearchParams(window.location.search);

    const uuid = urlParams.get("OnlineShopper_UUID") || undefined;
    const vin =
        urlParams.get("OnlineShopper_VIN") ||
        // data-initial-vin is used to give us magic link like behavior on sites where OS isn't loaded until a CTA is clicked (DDC)
        document.getElementById("_di-onlineshopper-loader")?.getAttribute("data-initial-vin") ||
        undefined;
    const initialEntries = mapInitialRoutes(uuid, urlParams);

    return { uuid, vin, initialEntries };
}

function mapInitialRoutes(uuid: string | undefined, params: { get: (arg: string) => any }): undefined | [string] {
    if (!uuid) {
        return undefined;
    }
    const route = params.get("OnlineShopper_Route");
    return route && route === "message-center" ? ["/my-garage/message-center"] : undefined;
}
